import { render, staticRenderFns } from "./ApmsBasicPhenophaseCategory.vue?vue&type=template&id=eb18080e&scoped=true&"
import script from "./ApmsBasicPhenophaseCategory.vue?vue&type=script&lang=js&"
export * from "./ApmsBasicPhenophaseCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb18080e",
  null
  
)

export default component.exports